import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';
@Injectable({
  providedIn: 'root'
})
export class VendorService {

  constructor(private httpClientService: HttpClientService) { }

  public getAllVendor(data: any) {
    return this.httpClientService.post(`${CONFIG.VENDOR.GETALLVENDOR}`, data);
  }

  public getVendorById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.VENDOR.GETVENDOR}?${queryParam}`);
  }
  public createVendor(data: any) {
    return this.httpClientService.post(`${CONFIG.VENDOR.CREATEVENDOR}`,data);
  }

  public updateVendor(data:any){
    return this.httpClientService.post(`${CONFIG.VENDOR.UPDATEVENDOR}`,data);
  }

  public deleteVendor(data: any) {
    return this.httpClientService.post(`${CONFIG.VENDOR.DELETEVENDOR}`,data);
  }

  public autogenerateVendorCode() {
    return this.httpClientService.get(CONFIG.VENDOR.AUTOGENERATE_VENDORCODE);
  }

  public checkVendorCode(data:any){
    return this.httpClientService.get(`${CONFIG.VENDOR.CHECK_VENDOR_CODE}?VendorCode=${data}`);
  }
  public autoSearchVendor(seachkey:string){
    return this.httpClientService.get(`${CONFIG.VENDOR.AUTOSEARCHVENDOR}?searchText=${seachkey}`);
  }

  public uploadVendorImage(vendorId:number,formData: FormData) {
    return this.httpClientService.post(`${CONFIG.VENDOR.UPLOAD_VENDOR_IMAGE}/${vendorId} `, formData);
  }

   public getVendorLookup(data: any) {
    return this.httpClientService.post(`${CONFIG.VENDOR.GETVENDORLOOKUP}`, data);  
  }
  public getOutstandingAmount(VendorId: string | number) {
  return this.httpClientService.get(`${CONFIG.VENDOR.GETOUTSTANDINGAMOUNT}?vendorId=${VendorId}`);
  }

  //for vendor bank lookup
  public CreateVendorBank(data: any) {
    return this.httpClientService.post(`${CONFIG.VENDOR.CREATE_VENDOR_BANK}`, data);
  }

   public getVendorBank(data: any) {
    return this.httpClientService.post(`${CONFIG.VENDOR.GET_VENDOR_BANK}`, data);
  }

    public deleteVendorBank(data: any[]) {
    return this.httpClientService.post(`${CONFIG.VENDOR.DELETE_VENDOR_BANK}`,data); 
  } 

  public updateVendorBank(data: any) {
    return this.httpClientService.post(`${CONFIG.VENDOR.UPDATE_VENDOR_BANK}`, data);
  }

  public setPrimaryVendorBank(payload: { vendorBankAccountId: number; vendorId: number; }) {
    return this.httpClientService.post(CONFIG.VENDOR.SET_PRIMARY_BANK, payload);
  }

  public getVendorCredits(vendorId: string | number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GETVENDORCREDITS}?vendorId=${vendorId}`);
  }

}
